import React from 'react'
import HTag from '@/lib/HTag'
import CTA from '@/lib/CTA'
import Img from '@/lib/Img'

const NewsListCTA = ({ heading, description, cta, image }) => (
	<article className="p-4 bg-white text-grounding-navy richtext">
		<figure>
			<Img image={image} alt={heading.text} />
		</figure>
		<HTag className="h2" {...heading} />
		{!!description && <p>{description}</p>}
		<p><CTA {...cta} /></p>
	</article>
)

export default NewsListCTA
